<template>
  <div class="w2-mask" @click="handleClose" v-if="dialogVisible">
    <div class="w2-dialog" @click.stop.prevent :style="{ width: width }">
      <div class="dialog_header">
        <div class="dialog_title">{{ title }}</div>
      </div>
      <div class="dialog_content">
        <slot></slot>
      </div>
      <div class="dialog_footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "w2-dialog",
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: "Title",
    },
    width: {
      type: String,
      default: "600px",
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  watch: {
    visible(value) {
      if (value) {
        if (this.appendToBody) {
          this.dialogVisible = value;
          document.body.append(this.$el);
        } else {
          this.dialogVisible = value;
        }
      } else {
        this.dialogVisible = value;
      }
    },
  },
  methods: {
    handleClose() {
      if (this.closeOnClickModal) {
        this.$emit("update:visible", false);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.w2-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  overflow: auto;
  z-index: 3001;
}
.w2-dialog {
  min-width: 200px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
}

.w2-dialog .dialog_header {
  height: 44px;
  line-height: 44px;
  text-align: left;
  border-bottom: 1px solid #ccc;
  padding: 0 15px;
}
.w2-dialog .dialog_title {
  font-size: 16px;
  font-weight: bold;
  color: #2c3e50;
}
.w2-dialog .dialog_footer {
  min-height: 44px;
  text-align: right;
  border-top: 1px solid #ccc;
  padding: 10px 15px;
  box-sizing: border-box;
}

.w2-dialog .dialog_content {
  overflow: auto;
  padding: 10px 15px;
  min-height: 50px;
}
</style>
